<h3-info>
  <div class="row" *ngFor="let inputData of inputData$ | async">
    <strong class="col-xs-2">{{ inputData.name }}:</strong>
    <div class="col-xs-10">
      <ng-container *ngIf="inputFormat(inputData.name) !== 'URL'">
        {{ getValue(inputData.name) }}
      </ng-container>
      <ng-container *ngIf="inputFormat(inputData.name) === 'URL'">
        <a
          [href]="getUrl(inputData.name)"
          target="_blank"
          rel="noopener"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
          (mouseover)="inputData.isPopoverOpen = true"
          (mouseout)="inputData.isPopoverOpen = false"
        >
          {{ getUrl(inputData.name) }}
        </a>
        <ng-template
          cdkConnectedOverlay
          [cdkConnectedOverlayOrigin]="trigger"
          [cdkConnectedOverlayOpen]="inputData.isPopoverOpen"
        >
          <div class="popover-with-header mat-elevation-z4">
            <img [src]="getUrl(inputData.name)" />
          </div>
        </ng-template>
        <!-- preload the asset, ready for mouseovering -->
        <img class="hidden" [src]="getUrl(inputData.name)" />
      </ng-container>
    </div>
  </div>
</h3-info>
